"use strict";
const angular = require("angular");
import _ from "lodash";

export class AddUserController {
  user = {};
  title = "ADD USER";
  buttonLabel = "Create";

  /*@ngInject*/
  constructor(
    appConfig,
    $uibModalInstance,
    $state,
    ngToast,
    Auth,
    $http,
    user
  ) {
    "ngInject";

    this.isAdmin = Auth.isAdminSync() || Auth.isHccAdminSync();

    this.$http = $http;
    this.modal = $uibModalInstance;
    this.ngToast = ngToast;

    if (user) {
      console.log("User is: ", user);
      this.user = user;
      if (this.user.Operation) {
        this.user.OperationId = this.user.Operation.id;
        Reflect.deleteProperty(this.user.Operation);
      }

      this.title = "EDIT USER";
      this.buttonLabel = "Update";
    }

    Auth.getCurrentUser().then(currentUser => {
      console.log("user: ", currentUser);
      this.userRoles = [];

      _.forEach(appConfig.userRoles, role => {
        if (role == currentUser.role) {
          this.userRoles.push(role);
          return false;
        }

        this.userRoles.push(role);
      });
    });

    if (this.isAdmin) {
      $http.get("/api/operations/").then(operations => {
        console.log(operations);
        this.operations = operations.data;
      });
    }
  }

  create() {
    let missing = [];

    if (!this.user.name) {
      missing.push("Name");
    }
    if (!this.user.email) {
      missing.push("Email");
    }
    if (!this.user.role) {
      missing.push("Role");
    }

    if (this.isAdmin && !this.user.OperationId) {
      missing.push("Operation");
    }

    if (missing.length > 0) {
      this.error = `Cannot create user, the following are required: ${missing}`;
      return;
    }

    if (this.buttonLabel == "Update") {
      this.$http.put("/api/users/", this.user).then(
        result => {
          console.log("rsp:", result);
          this.modal.close(result.data);
        },
        error => {
          if (error.data.name == "SequelizeUniqueConstraintError") {
            this.ngToast.create({
              className: "danger",
              content: "Error: That email address is already in use."
            });
          } else {
            this.ngToast.create({
              className: "danger",
              content: `Error: An error occured: ${error.data.name}: ${error.data.message}`
            });
          }
        }
      );
    } else {
      this.$http.post("/api/users/", this.user).then(
        result => {
          console.log("rsp:", result);
          this.modal.close(result.data);
        },
        error => {
          if (error.data.name == "SequelizeUniqueConstraintError") {
            this.ngToast.create({
              className: "danger",
              content: "Error: That email address is already in use."
            });
          } else {
            this.ngToast.create({
              className: "danger",
              content: `Error: An error occured: ${error.data.name}: ${error.data.message}`
            });
          }
        }
      );
    }
  }

  cancel() {
    this.modal.close();
  }
}

export default angular
  .module("hccApp.addUser", [])
  .controller("AddUserController", AddUserController).name;



// WEBPACK FOOTER //
// ./client/app/users/addUser.controller.js